import React from 'react';
import { Menu } from '@headlessui/react';
import { useAuth } from '../context/AuthContext';
import '../styles/userDropdown.css';

const UserDropdown = () => {
    const { userProfile, handleLogout, openLoginModal } = useAuth();

    if (userProfile.code === 2) {
        return (
            <div className="user-profile-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                <Menu as="div" className="user-dropdown">
                    <Menu.Button className="user-dropdown-control">
                        <span className="user-name">{userProfile.displayName}</span>
                        <img src={userProfile.photoURL} alt="Profile" />
                    </Menu.Button>
                    <Menu.Items className="user-dropdown-menu">
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    onClick={handleLogout}
                                    className={`logout-menu-item ${active ? 'is-active' : ''}`}
                                >
                                    Logout
                                </button>
                            )}
                        </Menu.Item>
                    </Menu.Items>
                </Menu>
            </div>
        );
    }

    if (userProfile.code === 3 || userProfile.code === 1) {
        return (
            <div>
                <button
                    style={{
                        background: '#FF5B15',
                        width: '100px',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '8px 20px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        fontSize: '16px',
                    }}
                    onClick={openLoginModal}
                >
                    Sign In
                </button>
            </div>
        );
    }

    return null;
};

export default UserDropdown;
